import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_COMPROVAR } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = {
    latitud: false,
    longitud: false
};

const esCoordenadaBuida = coordenada => coordenada === undefined || coordenada === null || coordenada === '';

const coordenades = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_COMPROVAR: {
            // Si no hi ha cap tipus de coordenades ambdues, latitud i longitud, no estan informades
            const { coordenades } = action.dades;
            if (!coordenades) return {
                latitud: true,
                longitud: true
            };

            const { latitud, longitud } = coordenades;
            return {
                latitud: esCoordenadaBuida(latitud),
                longitud: esCoordenadaBuida(longitud)
            };
        }

        default:
            return state;
    }
};

export default coordenades;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/errors/coordenades.js